module.exports = {
      id: "more-usage",
      viewBox: "0 0 34 10",
      url: "img/" + "sprite.svg#more-usage",
      toString: function () {
        return this.url;
      }
    }